<template>
  <div>
    <div class="row">
      <div class="col-sm">
        <h2>
          Hello,
          <span v-if="$auth.ready()">{{ $auth.user().username }}</span>
        </h2>
      </div>
    </div>

    <div class="row">
      <div class="col-sm p-3">
        <button
          class="btn btn-sm btn-outline-primary mr-4"
          v-on:click="moveToWeightCreateView()"
        >+ New weighing result</button>

        <button
          class="btn btn-sm btn-outline-primary"
          v-on:click="moveToWaistCreateView()"
        >+ New waist measurement</button>
      </div>
    </div>

    <div id="profile-status">
      <p>
        You have currently
        <b>{{ waistMeasurementCount }}</b> waist measurements and
        <b>{{ weighingResultCount}}</b> weighing results.
      </p>
    </div>

    <div id="quick-links"></div>

    <h2>Newest measurements</h2>

    <div id="profile-chart" v-if="store.hasMeasurementsInStore()">
      <line-chart :options="chartOptions" :chart-data="datacollection"></line-chart>
    </div>

    <div v-else>You have no measurements yet. Make sure to add something right away.</div>
  </div>
</template>

<script>
import { store } from "@/store.js";
import LineChart from "../components/LineChart.js";

export default {
  name: "Profile",
  components: {
    LineChart
  },
  data: function() {
    return {
      store: store,
      username: "UserNameHolder",
      chartDataWeighingResults: [],
      chartDataWaistMeasurements: [],
      chartColors: {
        red: "rgb(255, 99, 132)",
        orange: "rgb(255, 159, 64)",
        yellow: "rgb(255, 205, 86)",
        green: "rgb(75, 192, 192)",
        blue: "rgb(54, 162, 235)",
        purple: "rgb(153, 102, 255)",
        grey: "rgb(201, 203, 207)"
      },
      maxWaist: 0,
      maxWeight: 0,
      minWaist: 0,
      minWeight: 0,
      datacollection: {},
      chartData: [],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          line: {
            tension: 0
          }
        },
        scales: {
          xAxes: [
            {
              type: "time",
              time: {
                // unit: "week",
                displayFormats: {
                  day: "DD.MM.YYYY",
                  week: "DD.MM.YYYY",
                  month: "MM/YYYY"
                }
              }
            }
          ],
          yAxes: [
            {
              // id: "A",
              type: "linear",
              // stepSize: 10,
              position: "left",
              ticks: {
                // beginAtZero: true,
                suggestedMin: 0,
                suggestedMax: 150,
                stepSize: 5
              },
              display: true,
              scaleLabel: {
                display: false,
                labelString: "Measurement"
              }
            }
          ]
        }
      }
    };
  },
  mounted() {},
  computed: {
    waistMeasurementCount: function() {
      return this.store.state.waistMeasurements.length;
    },
    weighingResultCount: function() {
      return this.store.state.weighingResults.length;
    }
  },
  created: function() {
    this.convertChartDataWaistMeasurements();
    this.convertChartDataWeighingResults();

    let max = Math.max(this.maxWaist, this.maxWeight);
    let min = Math.min(this.minWaist, this.minWeight);

    let yMax = max + (5 - (max % 5));
    let yMin = min - (min % 5);

    if (yMax == max) yMax = yMax + 5;

    if (yMin == min) yMin = yMin - 5;

    this.chartOptions.scales.yAxes[0].ticks.suggestedMax = yMax;
    this.chartOptions.scales.yAxes[0].ticks.suggestedMin = yMin;

    this.fillData();
  },
  methods: {
    initData: function() {},
    filterRecentMeasurements: function(m) {
      let measurementDateTime = this.store.getMeasurementDatetime(m);

      return this.moment().diff(measurementDateTime, "days") <= 365;
    },
    convertChartDataWaistMeasurements() {
      let self = this;

      let waistMeasurements = store.state.waistMeasurements.filter(
        this.filterRecentMeasurements
      );
      // Sort
      waistMeasurements.sort(this.store.compareByDatetimeOldestFirst);
      // Take 30 newest measurements
      waistMeasurements = waistMeasurements.slice(-30);

      this.maxWaist =
        Math.max.apply(
          Math,
          waistMeasurements.map(function(m) {
            return m.measurement;
          })
        ) / 10;

      this.minWaist =
        Math.min.apply(
          Math,
          waistMeasurements.map(function(m) {
            return m.measurement;
          })
        ) / 10;

      waistMeasurements.map(function(waistMeasurement) {
        let x = {};
        if (waistMeasurement.time == null) {
          x = self.moment(waistMeasurement.date);
        } else {
          x = self.moment(waistMeasurement.date + " " + waistMeasurement.time);
        }

        self.chartDataWaistMeasurements.push({
          x: x,
          y: waistMeasurement.measurement / 10
        });
      });
    },
    convertChartDataWeighingResults() {
      let self = this;

      let weighingResults = store.state.weighingResults.filter(
        this.filterRecentMeasurements
      );
      // Sort
      weighingResults.sort(this.store.compareByDatetimeOldestFirst);

      this.maxWeight =
        Math.max.apply(
          Math,
          weighingResults.map(function(m) {
            return m.weight;
          })
        ) / 1000;

      this.minWeight =
        Math.min.apply(
          Math,
          weighingResults.map(function(m) {
            return m.weight;
          })
        ) / 1000;

      // Take 30 newest measurements
      weighingResults = weighingResults.slice(-30);

      weighingResults.map(function(weighingResult) {
        let x = {};
        if (weighingResult.time == null) {
          x = self.moment(weighingResult.date);
        } else {
          x = self.moment(weighingResult.date + " " + weighingResult.time);
        }

        self.chartDataWeighingResults.push({
          x: x,
          y: weighingResult.weight / 1000
        });
      });
    },
    fillData() {
      this.datacollection = {
        // labels: [this.getRandomInt(), this.getRandomInt()],
        datasets: [
          {
            label: "Weight [kg]",
            fill: false,
            // yAxisID: "A",
            borderColor: this.chartColors.blue,
            backgroundColor: this.chartColors.blue,
            data: this.chartDataWeighingResults
          },
          {
            label: "Waist [cm]",
            fill: false,
            borderColor: this.chartColors.red,
            backgroundColor: this.chartColors.red,
            // yAxisID: "B",

            data: this.chartDataWaistMeasurements
          }
        ]
      };
    },
    moveToWeightCreateView() {
      this.store.state.weightView.cancelRoute = "profile";
      this.$router.push({
        name: 'weight.create'
      });
    },    
    moveToWaistCreateView() {
      this.store.state.waistView.cancelRoute = "profile";
      this.$router.push({
        name: 'waist.create'
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#profile-status {
}

#profile-chart {
  margin-top: 3em;
  margin-bottom: 2em;
  /* max-width: 800px; */
}
</style>
